import SchedulerListResultModelBase from '../_generated/modelBases/scheduler-list-result-model-base';

export default class SchedulerListResultModel extends SchedulerListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
